import { useEffect } from 'react';

const SITE_URL = 'https://lockievisuals.me';
const DEFAULT_IMAGE = `${SITE_URL}/LogoOne.png`;

const setMeta = (selector, attribute, key, value) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', value);
};

const upsertLink = (rel, href) => {
  let link = document.head.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', rel);
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

const useSEO = ({
  title = 'Lockie Visuals | Web Design, App Development & Digital Marketing Agency',
  description = 'Lockie Visuals is a full-service digital agency offering web development, mobile app development, graphic design, digital marketing, SaaS software and data intelligence to grow your brand.',
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
  noindex = false
} = {}) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;

    document.title = title;

    setMeta('meta[name="robots"]', 'name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
    setMeta('meta[name="description"]', 'name', 'description', description);
    setMeta('meta[property="og:title"]', 'property', 'og:title', title);
    setMeta('meta[property="og:description"]', 'property', 'og:description', description);
    setMeta('meta[property="og:url"]', 'property', 'og:url', url);
    setMeta('meta[property="og:image"]', 'property', 'og:image', image);
    setMeta('meta[property="og:type"]', 'property', 'og:type', type);
    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title);
    setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description);
    setMeta('meta[name="twitter:image"]', 'name', 'twitter:image', image);

    upsertLink('canonical', url);
  }, [title, description, path, image, type, noindex]);
};

export default useSEO;
